import { render, staticRenderFns } from "./EditSessie.vue?vue&type=template&id=126deb36&"
import script from "./EditSessie.vue?vue&type=script&lang=js&"
export * from "./EditSessie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/dev/tafelgasten.outlawz.dev/web/app/themes/expert/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('126deb36')) {
      api.createRecord('126deb36', component.options)
    } else {
      api.reload('126deb36', component.options)
    }
    module.hot.accept("./EditSessie.vue?vue&type=template&id=126deb36&", function () {
      api.rerender('126deb36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/scripts/vue/Sessies/EditSessie.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/Sessies/EditSessie.vue
// module id = 388
// module chunks = 0